import { Form, FormInstance, Input } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { UploadWrapperDiv } from '../lib/Antd/UploadWrapperDiv';
import { textValidationPattern } from '../utils/validationPatterns/inputValidationPattern';
import { IGeneralSettingsForm } from './GeneralSettings';
import { ImageUpload } from './ImageUpload';

const StyledFormItem = styled(Form.Item)`
  &&& {
    margin-top: 10px;
  }
`;
export interface ILogoSettingsTab {
  form: FormInstance<IGeneralSettingsForm>;
}

const LogoSettingsTab = ({ form }: ILogoSettingsTab) => {
  const { t } = useTranslation('geosecma-settings');
  return (
    <>
      <StyledFormItem
        label={t('municipalityName')}
        name="municipalityName"
        rules={[{ pattern: textValidationPattern, message: t('textValidationError') }]}
      >
        <Input placeholder={t('municipalityPlaceholder')} data-testid="municipalityNameInput" />
      </StyledFormItem>

      <UploadWrapperDiv>
        <ImageUpload form={form} fieldName="municipalityIcon" />
        <ImageUpload form={form} fieldName="municipalityLogo" />
      </UploadWrapperDiv>
    </>
  );
};

export default LogoSettingsTab;
